import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from 'formbird-services';

@Injectable({
  providedIn: 'root'
})
export class SclUtilUrlService {
  private documentModalService: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.documentModalService = this.formbirdInjectorService.get('DocumentModalService');
  }

  openLink(link, mode, componentScope?: any) {
    const openMode = mode ? mode : 'currentWindow';
    switch (openMode) {
      case 'currentWindow' :
        window.location.href = link;
        break;

      case 'newWindow':
        window.open(link);
        break;

      case 'popup' :
        window.open(link, link, 'height=300,width=600');
        break;

      case 'overlay':
        // componentScope.modalTitle = componentScope.componentDefinition.label;
        // componentScope.unsavedDocumentListId = componentScope.formParameters.unsavedDocumentListId;
        const documentId = this.getDocIdFromLink(link);
        this.documentModalService.openDocumentInModal(documentId, componentScope);
        break;

      case 'noDisplay' :
        break;
      default :
        window.location = link;
        break;
    }
  }

  getDocIdFromLink(link) {
    const lstIdx = link.lastIndexOf('/');
    if (!link || lstIdx === -1) {
      return null;
    } else {
      return link.substr(lstIdx + 1, link.length);
    }
  }

  // generateUUID() {
  //   var d = new Date().getTime();
  //   var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
  //     var r = (d + Math.random() * 16) % 16 | 0;
  //     d = Math.floor(d / 16);
  //     return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  //   });
  //   return uuid;
  // }
  //
  // openDirtyConfirmModal(unsavedDocumentListId,$ocModal,arg1) {
  //   var unsavedDocuments = ModifiedFieldService.getModifiedDocuments(unsavedDocumentListId);
  //   if(unsavedDocuments.length >0){
  //     logger.info('There is unsaved documents');
  //     var succFunc = function () {
  //       logger.info("Saving document sc-time-recorder");
  //       DocumentSaveService.save(unsavedDocumentListId);
  //       $ocModal.close(arg1);
  //     };
  //
  //     var discardFunc = function () {
  //       logger.info("Resetting form on discard of unsaved document");
  //       ModifiedFieldService.resetModifiedFields();
  //       ModifiedFieldService.removeTemplateFields(scope.tplItem.newTemplate);
  //       ModifiedFieldService.removeModifiedDocumentFields(scope.doc.documentId);
  //       $ocModal.close(arg1);
  //     };
  //
  //     var cancelFunc = function () {
  //       logger.info("Cancelling navigation due to unsaved changes");
  //       //$ocModal.close(arg1);
  //     };
  //
  //     ModalService.showDialog("Save Changes?", "WARNING", succFunc, cancelFunc, discardFunc);
  //     $('.swal2-content .btn-wrapper a:eq(0)').attr('style','color: rgba(108, 14, 135, 0.87)!important');
  //
  //   }else{
  //     logger.info('There is no unsaved documents');
  //     $ocModal.close(arg1);
  //   }
  // }

}

